module.exports = __webpack_public_path__ + "static/media/play-store-en-white.f9aa8e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/play-store-en-white.png
// module id = 761
// module chunks = 2